import StepTextWizard from "@/components/StepTextWizard";

const STEPS = [
  { n: 1, code: "1", key: "strengths", label: "Strengths", phase: "STRATEGY", placeholder: "Internal competitive advantages, core assets, unique competencies." },
  { n: 2, code: "2", key: "weaknesses", label: "Weaknesses", phase: "STRATEGY", placeholder: "Internal process bottlenecks, resource vulnerabilities, asset gaps." },
  { n: 3, code: "3", key: "opportunities", label: "Opportunities", phase: "STRATEGY", placeholder: "External market trends, competitor issues, technological shifts to exploit." },
  { n: 4, code: "4", key: "threats", label: "Threats", phase: "STRATEGY", placeholder: "External regulatory challenges, supply constraints, shifting market risks." },
];

export default function Swot() {
  return <StepTextWizard toolType="swot" steps={STEPS} accent="indigo" titlePlaceholder="SWOT matrix title…" defaultTitle="Untitled SWOT Matrix" viewPath={(id) => `/swot/${id}/view`} finaliseLabel="Finalise Matrix" testidPrefix="swot" />;
}
